const clients = [
	{alt:"Guardian" ,src: require('./clients/guardian.png')},
	{alt:"Parino" ,src: require('./clients/parino.png')},
	{alt:"Biofar SA" ,src: require('./clients/biofar sa.png')},
	{alt:"3 de Fierro" ,src: require('./clients/3 de fierro.png')},
	{alt:"3L Mayorista" ,src: require('./clients/3l mayorista.png')},
	{alt:"Arandu Pintureria" ,src: require('./clients/arandu-pintureria.png')},
	{alt:"Awana" ,src: require('./clients/awana.png')},
	{alt:"Babystore" ,src: require('./clients/babystore.png')},
	{alt:"Bluemotors" ,src: require('./clients/bluemotors.png')},
	{alt:"Brandon" ,src: require('./clients/brandon.png')},
	{alt:"Butter" ,src: require('./clients/butter.png')},
	{alt:"Caja Prestamos" ,src: require('./clients/caja prestamos.png')},
	{alt:"Che Camba" ,src: require('./clients/che camba.png')},
	{alt:"Colorshop" ,src: require('./clients/colorshop.png')},
	{alt:"Commers" ,src: require('./clients/commers.png')},
	{alt:"Corrientes Tenis" ,src: require('./clients/corrientes tenis.png')},
	{alt:"David Cabrera" ,src: require('./clients/david cabrera.png')},
	{alt:"El Pibe" ,src: require('./clients/el pibe.png')},
	{alt:"Electronica Prevenir" ,src: require('./clients/electronica prevenir.png')},
	{alt:"Espacio" ,src: require('./clients/espacio.png')},
	{alt:"Fragolina" ,src: require('./clients/fragolina.png')},
	{alt:"Garavano" ,src: require('./clients/garavano.png')},
	{alt:"Hidromat" ,src: require('./clients/hidromat.png')},
	{alt:"Imagenes Biogar" ,src: require('./clients/imagenes biofar.png')},
	{alt:"Incer" ,src: require('./clients/incer.png')},
	{alt:"Legui" ,src: require('./clients/legui.png')},
	{alt:"Masis" ,src: require('./clients/masis.png')},
	{alt:"Maxiventas" ,src: require('./clients/maxiventas.png')},
	{alt:"Medialunas" ,src: require('./clients/medialunas.png')},
	{alt:"Metal" ,src: require('./clients/metal.png')},
	{alt:"Mexe" ,src: require('./clients/mexe.png')},
	{alt:"Mixmotos" ,src: require('./clients/mixmotos.png')},
	{alt:"Mora" ,src: require('./clients/mora.png')},
	{alt:"Motomundo" ,src: require('./clients/motomundo.png')},
	{alt:"Nealed" ,src: require('./clients/nealed.png')},
	{alt:"Parque" ,src: require('./clients/parque.png')},
	{alt:"Pinta Pora" ,src: require('./clients/pinta pora.png')},
	{alt:"Purasalud" ,src: require('./clients/purasalud.png')},
	{alt:"Radio Libertad" ,src: require('./clients/radio libertad.png')},
	{alt:"Sanitarios Taragui" ,src: require('./clients/sanitarios taragui.png')},
	{alt:"Serwin" ,src: require('./clients/serwin.png')},
	{alt:"Simat" ,src: require('./clients/simat.png')},
	{alt:"Soy Natural" ,src: require('./clients/soy natural.png')},
	{alt:"Status" ,src: require('./clients/status.png')},
	{alt:"Tna" ,src: require('./clients/tna.png')},
	{alt:"tr" ,src: require('./clients/tr.png')},
	{alt:"Tres Caracoles" ,src: require('./clients/tres caracoles.png')},
	{alt:"Urbaterra" ,src: require('./clients/urbaterra.png')},
	{alt:"Varsovia" ,src: require('./clients/varsovia.png')},
	{alt:"Veo Veo" ,src: require('./clients/veo veo.png')},
	{alt:"Vestigium" ,src: require('./clients/vestigium.png')}
];

export default clients;


// WEBPACK FOOTER //
// ./client/assets/clientImages.js